export const ROUTES = {
    EVENTS: '/events',
    EVENT: '/v2/event',
    TEAM_SETTINGS: '/settings/team',
    VENUES_SEARCH: '/explore-venues',
    FAVORITE_VENUES: '/favorite-venues',
    PROFILE: '/profile',
    DISCOVER_HOME: '/discover',
    DISCOVER_EXPLORE: '/discover/explore-venues',
    SIGN_IN: '/sign-in',
} as const;

export const PROFILE_ROUTES = {
    ACCOUNT: 'account',
    NOTIFICATION: 'notification',
} as const;

export const EVENT_ROUTES = {
    VENUES_OVERVIEW: 'venues-overview',
    ACCEPTED_VENUE: 'accepted-venue',
    COLLABORATORS: 'collaborators',
    GUESTS: 'guest-list',
    GUEST_IMPORT: 'by-import',
    INVITE: 'invite',
    SPEND_TRACKER: 'spend-tracker',
    RESOURCES: 'resources',
    VENUES_SEARCH: 'venues-search',
    VENUE: 'venue',
} as const;

export const EVENT_INVITE_ROUTES = {
    NEW: 'new',
} as const;

export const EVENT_VENUE_ROUTES = {
    INFO: 'venue-info',
    INQUIRY: 'venue-inquiry',
    PROPOSAL: 'venue-proposal',
    CONTRACT: 'venue-contract',
    PAYMENT: 'venue-payment',
    MESSAGES: 'venue-messages',
} as const;

export const TEAM_SETTINGS_ROUTES = {
    TEAM_BRANDING: 'team-branding',
    TEAM_MANAGEMENT: 'team-management',
    BUSINESS_SETTINGS: 'business-settings',
    APPROVALS: 'approvals',
} as const;
